import { StyledMobileSearchFilterButton, StyledMobileSearchFilterDiv } from './mobileStyles';
import clearIcon from '../../icons/clearIcon.svg';
import { useMapStore } from 'contexts/RootStore.context';
import { keys } from 'lodash';
import { observer } from 'mobx-react';

export const MobileFilterButton = observer(({ onClick }: { onClick: () => void }) => {

  const { getAssetSearchParams, resetFilterForm, loadAssets, selectBeacon,
    // it should be here to re-render on clear the search
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    filterForm
  } = useMapStore()
  const filterParams = getAssetSearchParams()


  const shouldShowClearButton = keys(filterParams).length > 0
  const inSearchMode = keys(filterParams).length === 1 && "name_filter" in filterParams

  function handleClearSearchFilters() {
    resetFilterForm()
    selectBeacon(null)
    loadAssets()
  }

  return (
    <StyledMobileSearchFilterDiv>
      <StyledMobileSearchFilterButton onClick={onClick} id="search-filter-button">
        Search & Filter
      </StyledMobileSearchFilterButton>
      {shouldShowClearButton && (
        <StyledMobileSearchFilterButton id="clear-filter-button" className="--clear" onClick={handleClearSearchFilters}>
          Clear {inSearchMode ? 'Search' : 'Filter'} <img src={clearIcon} alt="clear" />
        </StyledMobileSearchFilterButton>
      )}
    </StyledMobileSearchFilterDiv>
  );
})
